import { Input } from '@/lib/base/forms/input/input';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons';

import type { PropertyInputProps } from './TextInput';

export const UrlInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  inputRef,
  placeholder,
  size = 'sm',
}) => {
  return (
    <Input
      type='url'
      value={(value as string) || ''}
      onChange={onChange}
      isDisabled={disabled}
      icon={getPropertyTypeIconComponent(propertyType)}
      placeholder={placeholder || 'https://example.com'}
      size={size}
      aria-label={propertyType.label}
      ref={inputRef}
    />
  );
};
